import React from "react";
import { Button } from "react-md";
import errorImg from "../../../../../../../assets/icons/payment/error_red_exclamation.svg";

/**
 * Terminal error screen for a failed cart approve (network / 409 conflict /
 * server error). "Okay" closes the dialog so the operator can refresh and
 * retry from the payment-details preview.
 */
const CartErrorInApprove = ({ onClose, errorText }) => {
  return (
    <div
      className="pld-screen pld-method-container"
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      <div style={{ marginTop: "25px" }}>
        <img src={errorImg} alt="error" height="80px" />
      </div>

      <div className="pld-note-container" style={{ marginTop: "25px" }}>
        <div className="pld-note-box">
          <span className="pld-bold">Error in approving cart</span>
        </div>
      </div>

      {errorText && <div style={{ marginTop: "10px" }}>{errorText}</div>}

      <div className="pld-center" style={{ marginTop: "10px" }}>
        <Button raised className="zy-btn-orange pld-main-btn" onClick={onClose}>
          Okay
        </Button>
      </div>
    </div>
  );
};

export default CartErrorInApprove;
